export default {
  name: 'LiveCard',
  props: {
    liveData: Object,
    menu: Object,
    liveCount: Number // 直播数量

  },

  data() {
    return {
      status: 0 // 2 直播中

    };
  },

  methods: {
    goDetail(id) {
      window.open(`/liveDetail.html?menuId=${this.menu.menu_id}&name=${this.menu.module_name}&id=${id}`);
    }

  }
};